module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-05-e07f3d59481bdaa98b1f965b8b807c96.jpg";